// extracted by mini-css-extract-plugin
export default {"closePageButton":"O5OX68","closePageButtonIcon":"RPfgRv"};